import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Anny',
    description:
        'Elevating brand identities, systems, and apps through collaborative motion design.',
    url: 'https://anny.studio',
    ogImage: '/images/canada-og.jpg'
}

export const navLinks = [
    { label: 'Artworks', href: '/projects' },
    { label: 'Thoughts', href: '/blog' },
    { label: 'About', href: '/about' },
    { label: 'Shop', href: '/shop' },
    { label: 'Start > Project', href: '/contact' }
]

export const socialLinks = [
    { label: 'LinkedIn', href: 'https://linkedin.com' },
    { label: 'Instagram', href: 'https://instagram.com' },
    { label: 'Dribbble', href: 'https://dribbble.com' }
]

export const contactEmail = 'hello@modulify.ai'
